import { IInvoiceGroupAddressOverrides, IInvoiceGroupOverrides, IInvoiceGroups } from "@llws/lift-entity-interfaces";
import { TInvoiceGroupAddressOverrides, TInvoiceGroupCommand, TInvoiceGroupOverrides, TInvoiceGroups } from "src/components/pages/InvoiceGroups/zodSchemas";

/**
 * Builds a command payload for invoice group save.
 * @param originalGroups The groups as originally loaded from the backend
 * @param editedGroups The current edited groups (may include new, updated, or removed)
 * @param editedOverrides The current edited overrides (may include new, updated, or removed)
 * @param overridesToDelete Set of override IDs to delete
 */
export const buildInvoiceGroupCommandPayload = (
  originalGroups: IInvoiceGroups[],
  editedGroups: IInvoiceGroups[],
  editedOverrides: IInvoiceGroupOverrides[],
  editedAddressOverrides: IInvoiceGroupAddressOverrides[],
  groupIdsToDelete: Set<number>,
  overridesToDelete: Set<number>,
  addressOverridesToDelete: Set<number>,
): TInvoiceGroupCommand => {
  const groupsToAdd = editedGroups.filter(g => typeof g.id === 'number' && g.id < 0);
  const groupsToUpdate = editedGroups.filter(g => typeof g.id === 'number' && g.id > 0);

  const overridesToAdd = editedOverrides.filter(o => !o.id);
  const overridesToUpdate = editedOverrides.filter(o => !!o.id);

  const addressOverridesToAdd = editedAddressOverrides.filter(o => !o.id);
  const addressOverridesToUpdate = editedAddressOverrides.filter(o => !!o.id);

  return {
    invoiceGroup: {
      add: groupsToAdd as TInvoiceGroups[],
      update: groupsToUpdate as TInvoiceGroups[],
      delete: Array.from(groupIdsToDelete),
    },
    invoiceGroupOverrides: {
      add: overridesToAdd as TInvoiceGroupOverrides[],
      update: overridesToUpdate as TInvoiceGroupOverrides[],
      delete: Array.from(overridesToDelete),
    },
    invoiceGroupAddressOverrides: {
      add: addressOverridesToAdd as TInvoiceGroupAddressOverrides[],
      update: addressOverridesToUpdate as TInvoiceGroupAddressOverrides[],
      delete: Array.from(addressOverridesToDelete),
    },
  };
};